<template>
  <BaseTypeEditShell
    base-type="offers"
    :title="data?.name || 'Angebot bearbeiten'"
    :subtitle="data?.name ? 'Angebot bearbeiten' : null"
    :in-review="isNeedsReview"
  >
    <OffersForm
      v-if="data"
      :initial-values="data"
      :categories="categories"
      :host-objects="hostObjects"
      :is-needs-review="isNeedsReview"
      :persist="updateObject"
      ref="offersForm"
    />
  </BaseTypeEditShell>
</template>

<script>
import {useObjectStore} from "@/stores/object";
import {useLocalizedObjectStore} from "@/stores/localized_objects";
import {useUserStore} from "@/stores/user";
import {useCategoryStore} from "@/stores/category";
import OffersForm from "@/pages/offers/Form.vue";
import BaseTypeEditShell from "@/components/base_type/BaseTypeEditShell.vue";

export default {
  components: {
    BaseTypeEditShell,
    OffersForm,
  },
  setup() {
    return {
      objectStore: useObjectStore(),
      localizedObjectStore: useLocalizedObjectStore(),
      userStore: useUserStore(),
      categoryStore: useCategoryStore(),
    }
  },
  data() {
    return {
      data: null,
      categories: [],
      hostObjects: [],
    }
  },
  created() {
    const objectPromise = this.localizedObjectStore.apiShow(this.$route.params.id, this.$route.params.lang)
    const hostObjectsPromise = this.objectStore.apiHostCandidates(this.$route.params.lang || 'de', this.$route.params.id)
    const categoriesPromise = this.categoryStore.index({ base_type: 'angebote' })

    Promise.all([objectPromise, hostObjectsPromise, categoriesPromise]).then(([{data}, hostResponse, categoryResponse]) => {
      this.categories = Array.isArray(categoryResponse.data)
        ? categoryResponse.data
        : categoryResponse.data?.categories || []
      this.hostObjects = Array.isArray(hostResponse.data?.host_objects)
        ? hostResponse.data.host_objects
        : []
      this.data = {
        ...data,
        host_object_setting: false,
        configured_host_object_id: data.configured_host_object_id ?? null,
        location_id: data.location_id ?? null,
        asset_ids: Array.isArray(data.assets) ? data.assets.map((asset) => asset.id) : [],
        categories_data: this.normalizeCategoriesData(data),
      }
    })

    this.userStore.fetchMyClients()
  },
  computed: {
    isNeedsReview() {
      return !!this.data?.needs_review
    },
  },
  methods: {
    getSelectedCategoryIds(data) {
      if (Array.isArray(data.categories_data)) {
        return data.categories_data.filter((item) => item.checked).map((item) => item.id)
      }

      if (Array.isArray(data.categories)) {
        return data.categories.map((category) => category.id)
      }

      return []
    },
    normalizeCategoriesData(data) {
      if (Array.isArray(data.categories_data) && data.categories_data.length) {
        return data.categories_data.map((item) => this.enrichCategoryField(item))
      }

      const selectedIds = new Set(this.getSelectedCategoryIds(data).map((id) => Number(id)))

      return this.categories.map((category) => ({
        ...category,
        checked: selectedIds.has(Number(category.id)),
      }))
    },
    enrichCategoryField(item) {
      const catalogCategory = this.categories.find((category) => Number(category.id) === Number(item.id))

      return {
        ...catalogCategory,
        ...item,
        group_name: item.group_name || catalogCategory?.group_name || null,
      }
    },
    async updateObject(values) {
      const payload = {...values, id: this.data.id, lang: this.$route.params.lang || 'de'}
      delete payload.description
      const {data: updated} = await this.localizedObjectStore.apiUpdate(payload)
      this.data = {...this.data, ...payload, ...updated}
      return this.data
    },
  },
}
</script>
